import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../../store";
import { Pages } from "../../../Utils/Types";

export interface DrawerState {
  title: Pages;
}

const initialState: DrawerState = {
  title: Pages.Dashboard,
};

export const DrawerSlice = createSlice({
  name: "header",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setTitle: (state, action: PayloadAction<Pages>) => {
      state.title = action.payload;
    },
  },

  extraReducers: (builder) => {},
});

export const { setTitle } = DrawerSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectTitle = (state: RootState) => state.drawer.title;

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.

export default DrawerSlice.reducer;
